import { createContext } from 'react';
import { FeatureFlags } from '../../types';

export interface FeatureData {
  features: FeatureFlags;
}

const initialContext: FeatureData = {
  features: {}
};

export default createContext<FeatureData>(initialContext);
